module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/id/1-ac4e5c4ca1b8450624ce04309969a83e.jpg";